export const dataPersones = [
  //Мария
  {
    key: "maria",
    className: "persona_02",
    title: "ДОЛЖНОСТЬ",
    name: "Например",
    text: "Цитата из интервью сотрудника, показывающая основную идею и ярко описывающая человека или его деятельность",
    url: "./img/team/maria.webp",
    numbers: [
      {
        key: "maria_num_1",
        num: "000+",
        desc: "описание"
      },
      {
        key: "maria_num_2",
        num: "00",
        desc: "длинное описание"
      },
      {
        key: "maria_num_3",
        num: "000",
        desc: "некое описание"
      },
      {
        key: "maria_num_4",
        num: "0",
        desc: "более длинное описание"
      }
    ],
    biografyTitle:
      "Цитата из интервью сотрудника, показывающая основную идею и ярко описывающая человека или его деятельность",
    biografy: [
      {
        key: "maria_biografy_1",
        paragraph:
          "Жили-были старик со старухой. Вот и говорит старик старухе: — Поди-ка, старуха, по коробу поскреби, по сусеку помети, не наскребешь ли муки на колобок."
      },
      {
        key: "maria_biografy_2",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      }
    ]
  },
  //Никита
  {
    key: "nikita",
    className: "persona_03",
    title: "ДОЛЖНОСТЬ",
    name: "Например",
    text: "Инвестирую сам и несколько раз обжигался — так я научился выбирать проекты с минимальными рисками. Уверен, что нельзя брать деньги инвесторов на проверку гипотез.",
    url: "./img/team/nikita.webp",
    numbers: [
      {
        key: "nikita_num_1",
        num: "000",
        desc: "инвестиций привлечено"
      },
      {
        key: "nikita_num_2",
        num: "000",
        desc: "сделок по продаже бизнеса"
      },
      {
        key: "nikita_num_3",
        num: "000",
        desc: "привлечено инвестиций в отдельный проект"
      },
      {
        key: "nikita_num_4",
        num: "0",
        desc: "инвест-проекта запущено «с нуля»"
      }
    ],
    biografyTitle:
      "Инвестирую сам и несколько раз обжигался — так я научился выбирать проекты с минимальными рисками. Уверен, что нельзя брать деньги инвесторов на проверку гипотез.",
    biografy: [
      {
        key: "nikita_biografy_1",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "nikita_biografy_2",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "nikita_biografy_3",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      }
    ]
  },
  //Дмтрий Дир
  {
    key: "dmitry",
    className: "persona_06",
    title: "ДОЛЖНОСТЬ",
    name: "Например",
    text: "Я считаю, что нельзя полностью исключить риски — но можно понять, покроет ли их потенциальный доход. Для этого всегда выясняю, какие цели у инвестора.",
    url: "./img/team/dima.webp",
    numbers: [
      {
        key: "dmitry_num_1",
        num: "000",
        desc: "инвестиций привлечено"
      },
      {
        key: "dmitry_num_2",
        num: "00+",
        desc: "сделок по продаже бизнеса"
      },
      {
        key: "dmitry_num_3",
        num: "0",
        desc: "привлечено инвестиций в отдельный проект"
      },
      {
        key: "dmitry_num_4",
        num: "0",
        desc: "объектов гостиничного бизнеса запущено"
      }
    ],
    biografyTitle:
      "Я считаю, что нельзя полностью исключить риски — но можно понять, покроет ли их потенциальный доход. Для этого всегда выясняю, какие цели у инвестора.",
    biografy: [
      {
        key: "dmitry_biografy_1",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "dmitry_biografy_2",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      }
    ]
  },
  //Александр К
  {
    key: "alexandr_k",
    className: "persona_04",
    title: "ДОЛЖНОСТЬ",
    name: "НАПРИМЕР",
    text: "Когда люди приходят с негативным опытом инвестиций, я объясняю им финансовые инструменты и учу сопоставлять риски с доходностью.",
    url: "./img/team/alex_k.webp",
    numbers: [
      {
        key: "alexandr_k_num_1",
        num: "0000",
        desc: "инвестиций привлечено"
      },
      {
        key: "alexandr_k_num_2",
        num: "0",
        desc: "сделок по продаже бизнеса"
      },
      {
        key: "alexandr_k_num_3",
        num: "00",
        desc: "привлечено инвестиций в отдельный проект"
      }
    ],
    biografyTitle:
      "Понимаю, что люди инвестируют, когда видят доход и его чёткие математические объяснения. С подозрением отношусь к проектам, которые требуют небольших вложений.",
    biografy: [
      {
        key: "alexandr_k_biografy_1",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "alexandr_k_biografy_2",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "alexandr_k_biografy_3",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      }
    ]
  },
  {
    key: "alexandr_k2",
    className: "persona_05",
    title: "ДОЛЖНОСТЬ",
    name: "НАПРИМЕР",
    text: "Когда люди приходят с негативным опытом инвестиций, я объясняю им финансовые инструменты и учу сопоставлять риски с доходностью.",
    url: "./img/team/alex_k.webp",
    numbers: [
      {
        key: "alexandr_k2_num_1",
        num: "0000",
        desc: "инвестиций привлечено"
      },
      {
        key: "alexandr_k2_num_2",
        num: "0",
        desc: "сделок по продаже бизнеса"
      },
      {
        key: "alexandr_k2_num_3",
        num: "00",
        desc: "привлечено инвестиций в отдельный проект"
      }
    ],
    biografyTitle:
      "Понимаю, что люди инвестируют, когда видят доход и его чёткие математические объяснения. С подозрением отношусь к проектам, которые требуют небольших вложений.",
    biografy: [
      {
        key: "alexandr_k2_biografy_1",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "alexandr_k2_biografy_2",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "alexandr_k2_biografy_3",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      }
    ]
  },
  {
    key: "alexandr_k3",
    className: "persona_06",
    title: "ДОЛЖНОСТЬ",
    name: "НАПРИМЕР",
    text: "Когда люди приходят с негативным опытом инвестиций, я объясняю им финансовые инструменты и учу сопоставлять риски с доходностью.",
    url: "./img/team/alex_k.webp",
    numbers: [
      {
        key: "alexandr_k3_num_1",
        num: "0000",
        desc: "инвестиций привлечено"
      },
      {
        key: "alexandr_k3_num_2",
        num: "0",
        desc: "сделок по продаже бизнеса"
      },
      {
        key: "alexandr_k3_num_3",
        num: "00",
        desc: "привлечено инвестиций в отдельный проект"
      }
    ],
    biografyTitle:
      "Понимаю, что люди инвестируют, когда видят доход и его чёткие математические объяснения. С подозрением отношусь к проектам, которые требуют небольших вложений.",
    biografy: [
      {
        key: "alexandr_k3_biografy_1",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "alexandr_k3_biografy_2",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      },
      {
        key: "alexandr_k3_biografy_3",
        paragraph:
          "Взяла старуха крылышко, по коробу поскребла, по сусеку помела и наскребла муки горсти две. Замесила муку на сметане, состряпала колобок, изжарила в масле и на окошко студить положила. Колобок полежал, полежал, взял да и покатился — с окна на лавку, с лавки на пол, по полу к двери, прыг через порог — да в сени, из сеней на крыльцо, с крыльца на двор, со двора за ворота, дальше и дальше."
      }
    ]
  },
]
